import { CircularProgress } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLModal } from "components/Tooltips/OLModal";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    progressWrapper: {
      display: "flex",
      alignItems: "cnter",
      justifyContent: "center",
    },
  }),
);

interface Props {
  isProcessingExport: boolean;
  setIsProcessingExport: (val: boolean) => void;
  infoTitle?: string;
  modalWidth?: number;
}

export const ExportProgressModal = ({
  isProcessingExport,
  setIsProcessingExport,
  infoTitle,
  modalWidth,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <OLModal
      open={isProcessingExport}
      onClose={() => setIsProcessingExport(false)}
      header={infoTitle || message({ id: "exportInProgress" })}
      modalWidth={modalWidth}
    >
      <div className={classes.progressWrapper}>
        <CircularProgress size={32} />
      </div>
    </OLModal>
  );
};
